.room {
  --mobile-edge: #0c0e0c;
  background: radial-gradient(
    ellipse at 50% 44%,
    #142d38 0%,
    #0a1921 44%,
    #050a0d 74%,
    #020405 100%
  );
}

.scene {
  transform-origin: 33% 94%;
  transition: transform 420ms cubic-bezier(0.2, 0.72, 0.2, 1);
}

.sceneFocused {
  transform: scale(1.52);
}

.room .scene::after {
  content: '';
  position: absolute;
  z-index: 2;
  inset: 0;
  pointer-events: none;
  background: radial-gradient(circle at 37% 32%, rgba(108, 201, 97, 0.045), transparent 25%);
}

.consoleWindow {
  position: absolute;
  z-index: 7;
  left: 29.1%;
  top: 51.4%;
  width: 9.4cqw;
  height: 13.3cqw;
  overflow: hidden;
  pointer-events: none;
}

.consoleFrame {
  position: absolute;
  inset: 0;
  overflow: hidden;
  opacity: 0;
}

.consoleFrame img {
  position: absolute;
  left: 0;
  top: -7.66cqw;
  width: 100%;
  max-width: none;
  height: auto;
  image-rendering: pixelated;
}

.consoleWindow[data-stage='idle'] .consoleFrame[data-frame='0'],
.consoleWindow[data-stage='ready'] .consoleFrame[data-frame='4'] {
  opacity: 1;
}

.consoleWindow[data-stage='inserting'] .consoleFrame[data-frame='0'] {
  animation: consoleFrameZero 620ms steps(1, end) both;
}

.consoleWindow[data-stage='inserting'] .consoleFrame[data-frame='1'] {
  animation: consoleFrameOne 620ms steps(1, end) both;
}

.consoleWindow[data-stage='inserting'] .consoleFrame[data-frame='2'] {
  animation: consoleFrameTwo 620ms steps(1, end) both;
}

.consoleWindow[data-stage='loading'] .consoleFrame[data-frame='3'] {
  animation: consoleReadThree 520ms steps(1, end) infinite;
}

.consoleWindow[data-stage='loading'] .consoleFrame[data-frame='4'] {
  animation: consoleReadFour 520ms steps(1, end) infinite;
}

.organizerStage {
  position: absolute;
  z-index: 6;
  left: 17.42%;
  top: 72.56%;
  width: 31.25cqw;
  aspect-ratio: 1500 / 640;
}

.organizer {
  position: absolute;
  z-index: 1;
  inset: 0;
  width: 100%;
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  background: transparent;
  cursor: zoom-in;
  image-rendering: pixelated;
}

.organizer img {
  display: block;
  width: 100%;
  height: auto;
  pointer-events: none;
}

.organizer:hover,
.organizer:focus-visible,
.organizer[aria-pressed='true'] {
  filter: brightness(1.08) drop-shadow(0 0 0.22cqw rgba(151, 223, 117, 0.55));
}

.organizer:focus-visible {
  outline: 0.18cqw solid #a8ed82;
  outline-offset: -8cqw;
}

.skillScreen {
  position: absolute;
  z-index: 5;
  left: 19.7%;
  top: 14.2%;
  width: 33.3%;
  height: 34.8%;
  overflow: hidden;
  padding: 2.1cqw;
  color: #6a8f70;
  text-shadow: 0 0 6px rgba(115, 217, 91, 0.35);
  box-shadow:
    0 0 2cqw rgba(99, 238, 102, 0.2),
    inset 0 0 2.8cqw rgba(99, 238, 102, 0.09);
  container-type: inline-size;
}

.skillScreen::after {
  content: '';
  position: absolute;
  inset: 0;
  pointer-events: none;
  opacity: 0.12;
  background: repeating-linear-gradient(0deg, transparent 0 4px, #75d46a 5px);
}

.skillScreenOn {
  color: var(--green);
  animation:
    tvBoot 0.45s steps(3, end),
    tvGlow 4.8s steps(1, end) 0.45s infinite;
}

.idlePrompt {
  position: absolute;
  z-index: 20;
  inset: 7%;
  display: grid;
  place-content: center;
  justify-items: center;
  gap: 4cqw;
  padding: 5cqw;
  border: 1cqw solid #5cad52;
  color: #67b95e;
  background: rgba(1, 8, 3, 0.95);
  text-align: center;
  box-shadow: inset 0 0 8cqw rgba(115, 217, 91, 0.13);
  animation: idlePromptIn 0.36s steps(4, end) both;
}

.idlePrompt span {
  font-size: clamp(4px, 2cqw, 8px);
}
.idlePrompt b {
  color: #cfffad;
  font-size: clamp(7px, 3.3cqw, 14px);
  line-height: 1.65;
  animation: idlePromptBlink 1.2s steps(2, end) infinite;
}

.projectIdlePrompt {
  border-color: #d8c45b;
  color: #d8c45b;
  background: rgba(7, 12, 10, 0.96);
  box-shadow: inset 0 0 8cqw rgba(243, 216, 75, 0.12);
}

.projectIdlePrompt b {
  color: #fff1a6;
}

.emptyScreen,
.loadedScreen {
  position: relative;
  z-index: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.emptyScreen {
  justify-content: center;
  align-items: center;
  gap: 1.8cqw;
  text-align: center;
}

.emptyScreen span,
.loadedScreen > span {
  color: #3f7245;
  font-size: clamp(4px, 1.7cqw, 8px);
  letter-spacing: 0.08em;
}

.emptyScreen b {
  color: #8de176;
  font:
    400 clamp(12px, 6cqw, 28px) / 1.45 'Press Start 2P',
    monospace;
}

.emptyScreen small {
  color: #5aa05a;
  font-size: clamp(4px, 1.8cqw, 8px);
  animation: prompt 1.1s steps(2) infinite;
}

.loadedScreen {
  justify-content: center;
  gap: 1.1cqw;
}

.loadedScreen > b {
  overflow: hidden;
  color: #cfffad;
  font:
    400 clamp(12px, 7.2cqw, 31px) / 1.2 'Press Start 2P',
    monospace;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.loadedScreen > small {
  color: #7bc66b;
  font-size: clamp(4px, 1.9cqw, 8px);
}

.loadedScreen > strong {
  color: #adf58e;
  font-size: clamp(5px, 2.3cqw, 10px);
}

.loadedScreen > em {
  overflow: hidden;
  color: #527c55;
  font:
    normal 400 clamp(4px, 1.55cqw, 7px) / 1.5 'Press Start 2P',
    monospace;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.skillMeter {
  width: 100%;
  height: 1.8cqw;
  min-height: 5px;
  padding: 0.35cqw;
  border: 0.45cqw solid #476b49;
  background: #061009;
}

.skillMeter i {
  display: block;
  width: var(--skill-value);
  height: 100%;
  background: repeating-linear-gradient(90deg, #7ee26a 0 1.5cqw, #3e9d44 1.5cqw 1.9cqw);
  animation: skillLoad 1.1s steps(12, end) both;
}

.cartridgeField {
  position: absolute;
  z-index: 2;
  inset: 0;
  pointer-events: none;
}

.cartridge {
  position: absolute;
  left: var(--slot-x);
  top: var(--slot-y);
  width: 17.6%;
  aspect-ratio: 16 / 9;
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  background-color: transparent;
  background-image: var(--sprite);
  background-repeat: no-repeat;
  background-position: 0 0;
  background-size: 200% 100%;
  cursor: pointer;
  --fly-x: var(--dfly-x);
  --fly-y: var(--dfly-y);
  transform: translate(-50%, -50%);
  transition: none;
  pointer-events: auto;
  image-rendering: pixelated;
}

.cartridge::after {
  content: '';
  position: absolute;
  inset: 7% 11%;
}

.cartridge:hover,
.cartridge:focus-visible {
  z-index: 12;
  background-position: 100% 0;
}

.cartridge:focus-visible {
  filter: drop-shadow(0 0 0.28cqw #a8ed82);
}

.cartridgeActive {
  z-index: 11;
  background-position: 100% 0;
  pointer-events: none;
  animation: insertCartridge 0.68s steps(8, end) forwards;
}

@keyframes prompt {
  50% {
    translate: 4px 0;
  }
}

@keyframes tvBoot {
  0% {
    opacity: 0;
    transform: scaleY(0.04);
  }
  55% {
    opacity: 1;
    transform: scaleY(0.04);
  }
  100% {
    transform: scaleY(1);
  }
}
@keyframes tvGlow {
  0%,
  96%,
  100% {
    filter: brightness(1);
  }
  97% {
    filter: brightness(0.65);
  }
  98% {
    filter: brightness(1.18);
  }
}
@keyframes skillLoad {
  from {
    width: 0;
  }
  to {
    width: var(--skill-value);
  }
}

@keyframes idlePromptIn {
  0% {
    opacity: 0;
    transform: scaleY(0.03);
  }
  55% {
    opacity: 1;
    transform: scaleY(0.03);
  }
  100% {
    opacity: 1;
    transform: scaleY(1);
  }
}
@keyframes idlePromptBlink {
  50% {
    opacity: 0.45;
  }
}

@keyframes insertCartridge {
  0% {
    transform: translate(-50%, -50%);
  }
  44% {
    transform: translate(calc(-50% + var(--fly-x)), calc(-50% + var(--fly-y) - 1.5cqw)) scale(0.72);
    opacity: 1;
  }
  45%,
  100% {
    transform: translate(calc(-50% + var(--fly-x)), calc(-50% + var(--fly-y))) scale(0.2);
    opacity: 0;
  }
}

@keyframes consoleFrameZero {
  0%,
  44% {
    opacity: 1;
  }
  45%,
  100% {
    opacity: 0;
  }
}

@keyframes consoleFrameOne {
  0%,
  44% {
    opacity: 0;
  }
  45%,
  69% {
    opacity: 1;
  }
  70%,
  100% {
    opacity: 0;
  }
}

@keyframes consoleFrameTwo {
  0%,
  69% {
    opacity: 0;
  }
  70%,
  100% {
    opacity: 1;
  }
}

@keyframes consoleReadThree {
  0%,
  54% {
    opacity: 1;
  }
  55%,
  100% {
    opacity: 0;
  }
}

@keyframes consoleReadFour {
  0%,
  54% {
    opacity: 0;
  }
  55%,
  100% {
    opacity: 1;
  }
}

@media (max-width: 680px) {
  .scene {
    transform-origin: 50% 88%;
  }
  .sceneFocused {
    transform: scale(1.2);
  }
  .consoleWindow {
    left: 33%;
    top: 44.5%;
    width: 12cqw;
    height: 16.5cqw;
  }
  .consoleFrame img {
    top: -9.78cqw;
  }
  .organizerStage {
    left: 6.17%;
    top: 64.2%;
    width: 87.9cqw;
    transform: scale(0.75);
  }
  .skillScreen {
    left: 20.7%;
    top: 22.8%;
    width: 40.5%;
    height: 20.8%;
    padding: 3.1cqw;
  }
  .emptyScreen {
    gap: 2.2cqw;
  }
  .emptyScreen b {
    font-size: clamp(10px, 7cqw, 21px);
  }
  .loadedScreen {
    gap: 1.3cqw;
  }
  .loadedScreen > b {
    font-size: clamp(10px, 7.5cqw, 22px);
  }
  .cartridge {
    --fly-x: var(--mfly-x);
    --fly-y: var(--mfly-y);
  }
}

@media (max-width: 680px) and (max-height: 760px) {
  .organizerStage {
    top: 52.8%;
  }
  .cartridge {
    --fly-x: var(--cfly-x);
    --fly-y: var(--cfly-y);
  }
}

@media (prefers-reduced-motion: reduce) {
  .idlePrompt,
  .idlePrompt b,
  .skillScreen,
  .skillMeter i,
  .cartridgeActive,
  .consoleFrame,
  .scene {
    animation-duration: 0.01ms;
    animation-iteration-count: 1;
  }
}
